import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-progress',
    templateUrl: './pr-progress.component.html',
    styleUrls: ['./pr-progress.component.scss'],
    standalone: false
})
export class PrProgressComponent implements OnInit {
  @Input() progress: number = 100;
  @Input() maxWidth: number = 100;
  @Input() color = '#3376f6';
  @Input() bgColor;
  @Input() displayText = true;
  @Input() size = 'normal';
  @Input() rounded = false;
  @Input() height = '18px';

  constructor() {}

  ngOnInit() {}
}
